import React from 'react'
import { connect } from 'react-redux';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import { paginationInfoSelector } from '../../../../Redux/Reducers/paginationReducer';
import {
  ordersSelector,
  getOrders,
  removeOrder
} from '../../../../Redux/Reducers/ordersReducer';
import { IOrder, IPagination } from '../../../../Utils/types';
import { EyeOutlined } from '@ant-design/icons';
import { Select, Empty, Modal } from 'antd';
import { localization } from '../../../../Utils/Localization/localization';
import { ViewOrderDrawer } from '../../../ViewOrderDrawer/ViewOrderDrawer';
import classes from './OrdersPage.module.scss';
import { Pagination } from '../../../Pagination/Pagination';
import { convertStatus } from '../../../../Utils/convertStatus';

interface StateProps {
  language: string,
  orders: [],
  paginationInfo: IPagination
}
interface DispatchProps {
  getOrders: (page: number, pageSize: number) => void,
  removeOrder: (id: number) => void
}
interface Props extends StateProps, DispatchProps { }
function OrdersPage(props: Props) {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [viewDrawer, setViewDrawer] = React.useState(false);
  const [currentOrderId, setCurrentOrderId] = React.useState(0);

  function handleGetOrders() {
    props.getOrders(page, pageSize);
  }

  React.useEffect(() => {
    handleGetOrders();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  function handleViewOrder(id: number) {
    setCurrentOrderId(id);
    setViewDrawer(true);
  }

  function handleRemove(id: number) {
    Modal.confirm({
      title: `${localization('delete', props.language)} ?`,
      onOk() {
        props.removeOrder(id);
      }
    });
  }

  function renderOrders() {
    return (
      <div>
        <ViewOrderDrawer
          orderId={currentOrderId}
          visible={viewDrawer}
          handleClose={() => { setViewDrawer(false) }}
          handleRemove={handleRemove}
        />
        <Select
          defaultValue={pageSize}
          style={{ width: '100px' }}
          onChange={(value) => setPageSize(value)}
        >
          <Select.Option value={10}>10</Select.Option>
          <Select.Option value={25}>25</Select.Option>
          <Select.Option value={50}>50</Select.Option>
        </Select>
        <ul>
          <li className={classes.OrderListHeader}>
            <div>
              <span>{localization('orderId', props.language)}</span>
            </div>
            <div>
              <span>{localization('date', props.language)}</span>
            </div>
            <div>
              <span>{localization('status', props.language)}</span>
            </div>
            <div></div>
          </li>
          {
            props.orders.map((order: IOrder) => {
              return (
                <li key={order.id} className={classes.Order}>
                  <div>
                    <span>{order.id}</span>
                  </div>
                  <div>
                    <span>{new Date(+order.date).toLocaleDateString()}</span>
                  </div>
                  <div>
                    <span>{localization(convertStatus(order.status), props.language)}</span>
                  </div>
                  <div className={classes.Btns}>
                    <EyeOutlined onClick={() => { handleViewOrder(order.id) }} />
                  </div>
                </li>
              );
            })
          }
        </ul>
        <Pagination
          handleChangePage={(value) => setPage(value)}
          paginationInfo={props.paginationInfo}
        />
      </div>
    );
  }

  return (
    <div className={classes.OrdersPage}>
      <h2>{localization('orders', props.language)}</h2>
      {
        props.orders && props.orders.length > 0
          ? renderOrders()
          : <Empty description={localization('noItems', props.language)} />
      }
    </div>
  );
}

function mapStateToProps(state: any): StateProps {
  return {
    language: languageSelector(state),
    orders: ordersSelector(state),
    paginationInfo: paginationInfoSelector(state)
  }
}
const mapDispatchToProps: DispatchProps = {
  getOrders,
  removeOrder
}

const ConnectedReportsPage = connect(mapStateToProps, mapDispatchToProps)(OrdersPage);

export { ConnectedReportsPage as OrdersPage };